"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
;
class ModelIterator {
    constructor(model, options) {
        var _a, _b;
        if (!model) {
            throw new Error('Expecting model');
        }
        this.refProperty = options === null || options === void 0 ? void 0 : options.refProperty;
        this.limit = (_a = options === null || options === void 0 ? void 0 : options.limit) !== null && _a !== void 0 ? _a : 100;
        this.sortKey = (_b = options === null || options === void 0 ? void 0 : options.sortKey) !== null && _b !== void 0 ? _b : 'createdAt';
        this.model = model;
    }
    forEach(func, filter) {
        return __awaiter(this, void 0, void 0, function* () {
            let skip = 0;
            const limit = this.limit;
            let records;
            let promises = [];
            const sortKeyDoc = {};
            sortKeyDoc[this.sortKey] = 1;
            do {
                records = yield this.model
                    .find(filter !== null && filter !== void 0 ? filter : {})
                    .populate(this.refProperty)
                    .sort(sortKeyDoc)
                    .skip(skip)
                    .limit(limit);
                for (const record of records) {
                    const p = func(record);
                    promises.push(p);
                }
                yield Promise.all(promises);
                promises = [];
                skip += records.length;
                console.log(`${this.model.collection.collectionName}: total processed: ${skip}`);
            } while (records && records.length);
        });
    }
}
exports.ModelIterator = ModelIterator;
//# sourceMappingURL=ModelIterator.js.map